(function() {
  var modalId = 'LoggedInCustomerGateModal';
  var modalName = 'logged-in-customer-gate';
  var formSelector = 'form.product-single__form[data-main-product-form="true"]';
  var triggerSelector = '.product-single__form .add-to-cart[data-login-required-trigger="true"]';
  var modalInstance;

  function getProductForm() {
    return document.querySelector(formSelector + '[data-login-required-product="true"]');
  }

  function getRestrictedButton(target) {
    var button = target.closest(triggerSelector);

    if (!button || button.dataset.customerLoggedIn === 'true') {
      return null;
    }

    return button;
  }

  function getFormFromButton(button) {
    return button ? button.closest('form.product-single__form') : null;
  }

  function getVariantId(form) {
    var variantInput = form.querySelector('[name="id"]');
    return variantInput ? variantInput.value : '';
  }

  function getQuantity(form) {
    var quantityInput = form.querySelector('[name="quantity"]');
    return quantityInput && quantityInput.value ? quantityInput.value : '1';
  }

  function buildReturnUrl(form) {
    var url = new URL(window.location.href);
    var variantId = getVariantId(form);
    var quantity = getQuantity(form);

    if (variantId) {
      url.searchParams.set('variant', variantId);
      url.searchParams.set('auto_add_variant', variantId);
    }

    url.searchParams.set('auto_add_qty', quantity);

    return url.pathname + url.search + url.hash;
  }

  function buildAccountUrl(baseUrl, returnUrl) {
    var separator = baseUrl.indexOf('?') === -1 ? '?' : '&';
    return baseUrl + separator + 'return_url=' + encodeURIComponent(returnUrl);
  }

  function updateModalLinks(form) {
    var returnUrl = buildReturnUrl(form);
    var loginLink = document.querySelector('[data-login-required-login-link]');
    var registerLink = document.querySelector('[data-login-required-register-link]');

    if (loginLink) {
      loginLink.href = buildAccountUrl(form.dataset.loginUrl, returnUrl);
    }

    if (registerLink) {
      registerLink.href = buildAccountUrl(form.dataset.registerUrl, returnUrl);
    }
  }

  function getModal() {
    var modalElement = document.getElementById(modalId);

    if (!modalElement || !window.theme || !theme.Modals) {
      return null;
    }

    if (!modalInstance) {
      modalInstance = new theme.Modals(modalId, modalName, {
        solid: true
      });
    }

    return modalInstance;
  }

  function interceptRestrictedProductSubmit(event) {
    var form = event.target.closest(formSelector);

    if (!form || form.dataset.loginRequiredProduct !== 'true' || form.dataset.customerLoggedIn === 'true') {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    updateModalLinks(form);

    var modal = getModal();
    if (modal) {
      modal.open();
      return;
    }

    window.location.href = buildAccountUrl(form.dataset.loginUrl, buildReturnUrl(form));
  }

  function interceptRestrictedProductClick(event) {
    var button = getRestrictedButton(event.target);

    if (!button) {
      return;
    }

    var form = getFormFromButton(button);
    if (!form) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    updateModalLinks(form);

    var modal = getModal();
    if (modal) {
      modal.open();
      return;
    }

    window.location.href = buildAccountUrl(form.dataset.loginUrl, buildReturnUrl(form));
  }

  function cleanAutoAddParams(url) {
    url.searchParams.delete('auto_add_variant');
    url.searchParams.delete('auto_add_qty');
    return url.pathname + url.search + url.hash;
  }

  function maybeAutoAddAfterLogin() {
    var form = getProductForm();

    if (!form || form.dataset.customerLoggedIn !== 'true') {
      return;
    }

    var url = new URL(window.location.href);
    var variantId = url.searchParams.get('auto_add_variant');
    var quantity = url.searchParams.get('auto_add_qty') || '1';

    if (!variantId) {
      return;
    }

    var variantInput = form.querySelector('[name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');

    if (variantInput) {
      variantInput.value = variantId;
    }

    if (quantityInput) {
      quantityInput.value = quantity;
    }

    window.history.replaceState({}, document.title, cleanAutoAddParams(url));

    window.setTimeout(function() {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
        return;
      }

      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }, 250);
  }

  function ensureCustomerReturnTo() {
    if (!window.theme || !theme.settings || !theme.settings.isCustomerTemplate) {
      return;
    }

    var url = new URL(window.location.href);
    var returnUrl = url.searchParams.get('return_url');

    if (!returnUrl) {
      return;
    }

    var forms = [];
    var loginForm = document.querySelector('#CustomerLoginForm form');
    var registerSubmit = document.getElementById('register-submit');
    var registerForm = registerSubmit ? registerSubmit.form : null;

    if (loginForm) {
      forms.push(loginForm);
    }

    if (registerForm) {
      forms.push(registerForm);
    }

    forms.forEach(function(form) {
      var input = form.querySelector('input[name="return_to"]');

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'return_to';
        form.appendChild(input);
      }

      input.value = returnUrl;
    });
  }

  function initLoggedInCustomerGate() {
    document.addEventListener('click', interceptRestrictedProductClick, true);
    document.addEventListener('submit', interceptRestrictedProductSubmit, true);
    ensureCustomerReturnTo();
    maybeAutoAddAfterLogin();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoggedInCustomerGate);
  } else {
    initLoggedInCustomerGate();
  }
})();
